var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoppingBag = function SvgShoppingBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.706 1.988a2.48 2.48 0 0 1 1.986.992l1.882 2.511c.322.43.496.953.496 1.49v12.548a2.484 2.484 0 0 1-2.481 2.483H5.412a2.484 2.484 0 0 1-2.482-2.483V6.98c0-.537.174-1.06.496-1.489l1.883-2.51a2.48 2.48 0 0 1 1.985-.993zM4.13 6.983V19.53a1.285 1.285 0 0 0 1.283 1.282H18.59a1.28 1.28 0 0 0 1.282-1.282V6.983zm11.636 2.634a.5.5 0 0 1 .5.5 4.265 4.265 0 1 1-8.53 0 .5.5 0 1 1 1 0 3.265 3.265 0 1 0 6.53 0 .5.5 0 0 1 .5-.5m-8.471-6.43a1.28 1.28 0 0 0-1.025.514L4.706 5.784h14.588L17.73 3.701a1.28 1.28 0 0 0-1.025-.514z"
  })));
};
export default SvgShoppingBag;